import React from 'react'
const UpIcon = () => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.934143 6L9.06588 6C9.45069 6 9.64672 5.43467 9.37082 5.09901L5.30495 0.152374C5.13796 -0.0507911 4.86206 -0.0507911 4.695 0.152374L0.629129 5.09901C0.353304 5.43467 0.549337 6 0.934143 6Z" fill="#78B856" />
    </svg>
  )
}

export default UpIcon